import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import '../scss/non-auth.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moLogin, { toggleLogin } from '@store/login';

interface IProps {}
interface IState {}

const LoginButton = styled(Button)(() => ({
  height: '36px',
  padding: '0 10px',
  marginTop: '20px',
  fontSize: '14px',
  lineHeight: 1,
  borderRadius: '5px',
}));

const NonAuth = (props: IProps, state: IState) => {
  const navi = useNavigate();

  useEffect(() => {
    return () => {};
  }, []);

  const onLogin = () => {
    toggleLogin(true);
  };

  return (
    <section className="non-auth-11">
      <strong>请您登录</strong>
      <LoginButton variant="contained" color="primary"
        onClick={onLogin}>登录查看
      </LoginButton>
      <span>登录之后可查看竞品分析报告，包含：招聘动态分析、人才需求分析、薪酬需求分析</span>
    </section>
  );
};

export default observer(NonAuth);
